import React from "react";
import { dateRange, initials } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

const BAR_WIDTHS = ["92%", "85%", "78%", "95%", "70%", "88%", "80%", "75%"];

export default function SkillBarsTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl shadow-2xl text-[13px] leading-snug flex overflow-hidden" data-testid="resume-live-preview">
      <div className="w-[36%] p-5" style={{ backgroundColor: "#0f172a" }}>
        <div className="w-12 h-12 rounded-full flex items-center justify-center text-white font-bold text-sm mb-3" style={{ backgroundColor: accent }}>{initials(draft.full_name)}</div>
        <h1 className="text-base font-bold text-white">{draft.full_name || "Your Name"}</h1>
        <div className="text-slate-400 text-[10px] mt-2 space-y-0.5">
          {[draft.contact_email, draft.contact_phone, draft.location].filter(Boolean).map((line) => <p key={line}>{line}</p>)}
        </div>
        {draft.skills.length > 0 && (
          <div className="mt-5">
            <h2 className="text-[10px] font-bold uppercase tracking-wider text-white/80 mb-2">Skills</h2>
            <div className="space-y-2">
              {draft.skills.map((sk, i) => (
                <div key={sk}>
                  <p className="text-white/85 text-[10px] mb-0.5">{sk}</p>
                  <div className="h-1 bg-white/15 rounded-full overflow-hidden"><div className="h-full rounded-full" style={{ width: BAR_WIDTHS[i % BAR_WIDTHS.length], backgroundColor: accent }} /></div>
                </div>
              ))}
            </div>
          </div>
        )}
        {draft.education.length > 0 && (
          <div className="mt-5">
            <h2 className="text-[10px] font-bold uppercase tracking-wider text-white/80 mb-1.5">Education</h2>
            {draft.education.map((ed, i) => <p key={i} className="text-white/80 text-[10px] mt-1">{ed.degree} {ed.field}<br />{ed.school}</p>)}
          </div>
        )}
      </div>
      <div className="w-[64%] p-6">
        {draft.target_role && <p className="text-slate-500 text-xs font-semibold uppercase tracking-wide">{draft.target_role}</p>}
        {draft.summary && <p className="text-slate-700 mt-2">{draft.summary}</p>}
        {draft.experience.length > 0 && (
          <div className="mt-4">
            <h2 className="text-xs font-bold uppercase tracking-wider" style={{ color: accent }}>Experience</h2>
            {draft.experience.map((e, i) => (
              <div key={i} className="mt-2">
                <p className="font-semibold text-slate-800">{e.title} — {e.company} <span className="text-slate-400 font-normal italic">({dateRange(e.start_date, e.end_date, e.current)})</span></p>
                <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
              </div>
            ))}
          </div>
        )}
        <ExtraResumeSections draft={draft} accent={accent} />
      </div>
    </div>
  );
}
